import { useCallback, useRef } from 'react';

import { showAlert } from 'components/shared/Alert/Alert';

/**
 * Lets a form with practice name fields hold a save until the person has seen what the rules
 * will store. Each field registers a gate; the form asks every gate before it saves.
 */
const usePracticeNameChecks = () => {
  const gates = useRef({});

  const registerNameCheck = useCallback((field, gate) => {
    gates.current[field] = gate;
    return () => {
      if (gates.current[field] === gate) delete gates.current[field];
    };
  }, []);

  const waitForNameChecks = useCallback(async () => {
    const results = await Promise.all(Object.values(gates.current).map((gate) => gate()));
    const held = results.some(Boolean);
    if (held) {
      showAlert({
        color: 'warning',
        title: 'Name will be reformatted',
        message:
          'See how it will be saved under the field. Tick "Keep the name exactly as typed" to override it, then save again.'
      });
    }
    return held;
  }, []);

  return { registerNameCheck, waitForNameChecks };
};

export default usePracticeNameChecks;
